import { forwardRef, createElement } from 'react';

function IconProductLedgerCard(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M7.797 9c.464 0 .91.184 1.237.513l6.229 6.228a1.75 1.75 0 010 2.475l-4.047 4.047a1.75 1.75 0 01-2.475 0l-6.228-6.229A1.75 1.75 0 012 14.797V10.75C2 9.784 2.784 9 3.75 9h4.047zM18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H14.5v-1.5h3.75a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V8H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM7.797 10.5H3.75a.25.25 0 00-.243.193l-.007.057v4.047a.25.25 0 00.033.125l.04.052 6.228 6.228a.25.25 0 00.3.04l.054-.04 4.047-4.047a.25.25 0 00.04-.3l-.04-.054-6.228-6.228a.25.25 0 00-.112-.064l-.065-.009zm-2.504 1.793a1 1 0 111.414 1.414 1 1 0 01-1.414-1.414zM15.75 9.5a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ProductLedgerCard = /*#__PURE__*/forwardRef(IconProductLedgerCard);

export default ProductLedgerCard;
//# sourceMappingURL=ProductLedgerCard.js.map
